import { useMemo } from "react";

/**
 * Detects whether the current device is a touch-primary device (tablet/mobile).
 * Uses navigator.maxTouchPoints as the primary signal rather than user agent strings,
 * since modern iPadOS reports desktop Safari user agents.
 *
 * Returns { isTouchDevice, isTablet } where:
 * - isTouchDevice: true if the device supports touch input as its primary mechanism
 * - isTablet: true if touch-capable with a screen width suggesting tablet (not phone)
 *
 * Note: These values are computed once and do not change during the session.
 */
export function useTouchDevice() {
    return useMemo(() => {
        const isTouchDevice = typeof navigator !== 'undefined'
            && navigator.maxTouchPoints > 1;

        const isTablet = isTouchDevice
            && typeof window !== 'undefined'
            && window.screen.width >= 768;

        return { isTouchDevice, isTablet };
    }, []);
}
